/* ========================================
   Artist Profile — Klydos Grid + Carousel
   ======================================== */

function renderKlydos(klydos, artistId) {
  const grid = document.getElementById("klydos-grid");
  const section = document.getElementById("section-klydos");
  const arrowLeft = document.getElementById("klydos-arrow-left");
  const arrowRight = document.getElementById("klydos-arrow-right");
  const klydosViewAll = document.getElementById("klydos-view-all");
  if (klydosViewAll && artistId) {
    klydosViewAll.href =
      "/pages/artist-all-klydos?id=" + encodeURIComponent(artistId);
  }

  const now = Date.now();
  const publishedKlydos = (klydos || []).filter(function (klydo) {
    return !klydo.publicTimestamp || klydo.publicTimestamp < now;
  });

  if (publishedKlydos.length === 0) {
    section.style.display = "none";
    return;
  }

  if (klydosViewAll) {
    klydosViewAll.style.display = publishedKlydos.length > 8 ? "" : "none";
  }

  const getFavoritesCount = (klydo) => {
    const stats = klydo && klydo.stats;
    if (!stats) return 0;
    if (typeof stats.favorites === "number") return stats.favorites;
    if (typeof stats.favs === "number") return stats.favs;
    return 0;
  };

  const sorted = publishedKlydos
    .slice()
    .sort(function (klydoA, klydoB) {
      return getFavoritesCount(klydoB) - getFavoritesCount(klydoA);
    })
    .slice(0, 8);

  grid.innerHTML = sorted
    .map(function (klydo, index) {
      const imageUrl = klydo.photoUrl || klydo.loopUrl || "";
      const mediaHtml =
        '<img src="' +
        escapeHtml(imageUrl) +
        '" alt="' +
        escapeHtml(klydo.name) +
        '" loading="lazy">';
      return (
        '<div class="artist-klydo-card" data-klydo-index="' +
        index +
        '">' +
        '<div class="artist-klydo-card__media-wrap">' +
        mediaHtml +
        "</div>" +
        '<div class="artist-klydo-card__name">' +
        escapeHtml(klydo.name || "") +
        "</div>" +
        "</div>"
      );
    })
    .join("");

  grid.addEventListener("click", function (event) {
    const card = event.target.closest(".artist-klydo-card");
    if (!card) return;
    const idx = parseInt(card.getAttribute("data-klydo-index"), 10);
    if (!isNaN(idx) && sorted[idx]) {
      openKlydoModal(sorted[idx]);
    }
  });

  /* Deep-link match against ALL published klydos (not just the top-8
     carousel), so `?klydoId=...` opens the modal for any of the artist's
     klydos, not only the ones currently visible. */
  openKlydoModalFromUrlIfPresent(publishedKlydos);

  function isMobile() {
    return window.innerWidth <= 760;
  }

  /* Carousel/clone logic only makes sense when originals don't fit in the
     wrapper — otherwise clones end up visible alongside the originals,
     showing the same klydo twice on page load. */
  const wrapper = grid.parentElement;

  function layoutCarousel() {
    const firstCard = grid.children[0];
    const gridStyles = window.getComputedStyle(grid);
    const gap = parseFloat(gridStyles.columnGap || gridStyles.gap) || 0;
    const cardStep = (firstCard ? firstCard.offsetWidth : 0) + gap;
    const wrapperWidth =
      wrapper && wrapper.clientWidth ? wrapper.clientWidth : window.innerWidth;
    const cardsPerViewport =
      cardStep > 0
        ? Math.max(1, Math.floor(wrapperWidth / cardStep))
        : sorted.length;
    if (sorted.length <= cardsPerViewport) {
      arrowLeft.style.display = "none";
      arrowRight.style.display = "none";
      /* Match the carousel's spacing/start position so the row looks the same
         as when it scrolls (cards 42px apart, aligned to the start of the
         wrapper). */
      grid.style.gap = "42px";
      grid.style.justifyContent = "flex-start";
      return;
    }

    grid.classList.add("artist-klydos__grid--scroll");

    if (isMobile()) {
      setupMobileScroll();
      return;
    }

    setupDesktopCarousel();
  }

  if (!wrapper || wrapper.clientWidth > 0) {
    layoutCarousel();
  } else if ("ResizeObserver" in window) {
    const readyObserver = new ResizeObserver(function () {
      if (wrapper.clientWidth > 0) {
        readyObserver.disconnect();
        layoutCarousel();
      }
    });
    readyObserver.observe(wrapper);
  } else {
    requestAnimationFrame(function () {
      requestAnimationFrame(layoutCarousel);
    });
  }

  /* ---- Mobile: infinite touch scroll ---- */
  function setupMobileScroll() {
    const wrapper = grid.parentElement;
    const cards = Array.from(grid.children);
    const totalCards = cards.length;
    const gap = 20;

    const track = document.createElement("div");
    track.className = "artist-klydos__track";
    track.style.display = "flex";
    track.style.gap = gap + "px";

    /* Start with just the originals — clones are added only if they overflow. */
    cards.forEach(function (card) {
      track.appendChild(card);
    });

    grid.innerHTML = "";
    grid.appendChild(track);
    grid.style.overflow = "visible";

    wrapper.style.overflow = "auto";
    wrapper.style.webkitOverflowScrolling = "touch";
    arrowLeft.style.display = "none";
    arrowRight.style.display = "none";

    /* Hide scrollbar */
    wrapper.style.scrollbarWidth = "none";
    wrapper.style.msOverflowStyle = "none";

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        /* If the originals don't overflow the viewport, a static row is enough;
           the [clone][original][clone] copies would only show duplicate cards. */
        if (track.scrollWidth <= wrapper.clientWidth) return;
        enableMobileLoop();
      });
    });

    function enableMobileLoop() {
      const originals = Array.from(track.children);

      originals.forEach(function (card) {
        const clone = card.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      });
      for (
        let cloneIndex = originals.length - 1;
        cloneIndex >= 0;
        cloneIndex--
      ) {
        const clone = originals[cloneIndex].cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.insertBefore(clone, track.firstChild);
      }

      let oneSetWidth = 0;
      let isTouching = false;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          const cardWidth = track.children[0].offsetWidth;
          oneSetWidth = totalCards * cardWidth + totalCards * gap;

          /* Start at the originals (second set) */
          wrapper.scrollLeft = oneSetWidth;
        });
      });

      wrapper.addEventListener(
        "touchstart",
        function () {
          isTouching = true;
        },
        { passive: true },
      );

      wrapper.addEventListener(
        "touchend",
        function () {
          isTouching = false;
          /* Check after momentum scrolling settles */
          checkWrap();
        },
        { passive: true },
      );

      let rafId = null;
      function checkWrap() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          if (isTouching || oneSetWidth === 0) return;

          const scrollPos = wrapper.scrollLeft;

          /* If scrolled into the first clone set (before originals) */
          if (scrollPos < oneSetWidth * 0.3) {
            wrapper.style.scrollBehavior = "auto";
            wrapper.scrollLeft = scrollPos + oneSetWidth;
            wrapper.style.scrollBehavior = "";
          } else if (scrollPos > oneSetWidth * 1.7) {
            /* If scrolled into the third clone set (after originals) */
            wrapper.style.scrollBehavior = "auto";
            wrapper.scrollLeft = scrollPos - oneSetWidth;
            wrapper.style.scrollBehavior = "";
          }
        });
      }

      /* Also check on scroll end for momentum */
      let scrollTimer;
      wrapper.addEventListener(
        "scroll",
        function () {
          if (isTouching) return;
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(checkWrap, 100);
        },
        { passive: true },
      );
    }
  }

  /* ---- Desktop: arrow-based carousel with clones ---- */
  function setupDesktopCarousel() {
    const wrapper = grid.parentElement;
    const GAP = 42;

    const track = document.createElement("div");
    track.className = "artist-klydos__track";
    while (grid.firstChild) track.appendChild(grid.firstChild);
    grid.appendChild(track);

    const originalCards = Array.from(track.children);
    const totalOriginal = originalCards.length;

    /* The seamless loop needs a clone set on each side of the originals. But
       when the originals already fit within the viewport those clones sit
       on-screen beside them and read as duplicate cards, so we only build the
       loop when the originals actually overflow. Measured inside rAF because
       the page shell may still be hidden when the klydos request resolves. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (track.scrollWidth <= wrapper.clientWidth) {
          arrowLeft.classList.add("artist-klydos__arrow--hidden");
          arrowRight.classList.add("artist-klydos__arrow--hidden");
          return;
        }
        enableInfiniteLoop();
      });
    });

    function enableInfiniteLoop() {
      originalCards.forEach(function (card) {
        track.appendChild(card.cloneNode(true));
      });
      for (let cloneIndex = totalOriginal - 1; cloneIndex >= 0; cloneIndex--) {
        track.insertBefore(
          originalCards[cloneIndex].cloneNode(true),
          track.firstChild,
        );
      }

      let isAnimating = false;
      let currentIndex = totalOriginal;
      let cachedStep = 0;

      function getStep() {
        if (cachedStep > 0) return cachedStep;
        const firstCard = track.children[0];
        if (firstCard && firstCard.offsetWidth > 0) {
          cachedStep = firstCard.offsetWidth + GAP;
        }
        return cachedStep || 191 + GAP;
      }

      function jumpTo(index) {
        track.style.transition = "none";
        currentIndex = index;
        track.style.transform =
          "translateX(" + -(currentIndex * getStep()) + "px)";
        track.offsetHeight;
      }

      function animateTo(index) {
        currentIndex = index;
        track.style.transition = "transform 0.35s ease";
        track.style.transform =
          "translateX(" + -(currentIndex * getStep()) + "px)";
      }

      cachedStep = 0;
      jumpTo(totalOriginal);

      arrowLeft.classList.remove("artist-klydos__arrow--hidden");
      arrowRight.classList.remove("artist-klydos__arrow--hidden");

      track.addEventListener("transitionend", function () {
        isAnimating = false;
        if (currentIndex < totalOriginal) {
          jumpTo(currentIndex + totalOriginal);
        } else if (currentIndex >= totalOriginal * 2) {
          jumpTo(currentIndex - totalOriginal);
        }
      });

      arrowLeft.addEventListener("click", function () {
        if (isAnimating) return;
        isAnimating = true;
        animateTo(currentIndex - 1);
      });

      arrowRight.addEventListener("click", function () {
        if (isAnimating) return;
        isAnimating = true;
        animateTo(currentIndex + 1);
      });

      window.addEventListener("resize", function () {
        if (!isMobile()) {
          cachedStep = 0;
          jumpTo(totalOriginal);
        }
      });
    }
  }
}
